import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import SharePointService from './services/sharepoint'

// Initialize MSAL and handle authentication before mounting app
async function initializeApp() {
  try {
    // Initialize MSAL
    await SharePointService.initialize();
    console.log('MSAL initialized successfully');

    // Check if user is authenticated
    const isAuthenticated = SharePointService.isAuthenticated();
    console.log('User authenticated:', isAuthenticated);

    if (isAuthenticated) {
      const user = SharePointService.getCurrentUser();
      console.log('Current user:', user?.username);
    }

    // Create and mount Vue app
    const app = createApp(App);
    
    // Make SharePointService globally available
    app.config.globalProperties.$sharepoint = SharePointService;
    
    // Use Vue Router
    app.use(router);
    
    app.mount('#app');
    
  } catch (error) {
    console.error('Error initializing app:', error);
    
    // Still mount the app even if there's an error
    const app = createApp(App);
    app.config.globalProperties.$sharepoint = SharePointService;
    app.use(router);
    app.mount('#app');
  }
}

// Start the application
initializeApp();
